
import {
    TenementQueryTool
} from "../tenements/TenementQueryTool "
import { Form } from "react-bootstrap"
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMap } from "@vis.gl/react-maplibre";
import { AssayQueryToolMapLibre } from "../soil-assay/AssayQueryTool";
import { MinedexQueryTool } from "../minedex/MinedexQueryTool";
import { faFilter, faMap, faLayerGroup, faQuestionCircle, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { DrillHoleQueryTool } from "../drill-hole/DrillHoleQueryTool";
import logo from '../../images/GoldfinderLogo.svg';

// Sidebar CSS styles
const styles = {
    sidebar: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        fontFamily: 'var(--gf-font-sans, "Poppins", sans-serif)',
    },
    header: {
        backgroundColor: 'white',
        padding: 'var(--gf-space-4, 16px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: '1px solid var(--gf-border-color, #E5E7EB)',
    },
    headerIcon: {
        fontSize: 'var(--gf-text-xl, 1.25rem)',
    },
    headerTitle: {
        fontSize: 'var(--gf-text-lg, 1.125rem)',
        fontWeight: 'var(--gf-font-semibold, 600)',
        margin: 0,
    },
    content: {
        flex: 1,
        overflowY: 'auto',
        padding: 'var(--gf-space-3, 12px)',
    },
    section: {
        marginBottom: 'var(--gf-space-4, 16px)',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--gf-space-2, 8px)',
        paddingBottom: 'var(--gf-space-2, 8px)',
        borderBottom: '2px solid var(--gf-primary-400, #FD7218)',
        marginBottom: 'var(--gf-space-3, 12px)',
    },
    sectionIcon: {
        color: 'var(--gf-primary-400, #FD7218)',
        fontSize: 'var(--gf-text-base, 1rem)',
    },
    sectionTitle: {
        fontSize: 'var(--gf-text-sm, 0.875rem)',
        fontWeight: 'var(--gf-font-semibold, 600)',
        color: 'var(--gf-secondary-700, #2D3238)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        margin: 0,
    },
    radioGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--gf-space-1, 4px)',
    },
    radioItem: {
        display: 'flex',
        alignItems: 'center',
        padding: 'var(--gf-space-2, 8px) var(--gf-space-3, 12px)',
        borderRadius: 'var(--gf-border-radius-md, 6px)',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        fontSize: 'var(--gf-text-sm, 0.875rem)',
    },
    overlayCard: {
        border: '1px solid var(--gf-border-color, #E5E7EB)',
        borderRadius: 'var(--gf-border-radius-lg, 8px)',
        marginBottom: 'var(--gf-space-2, 8px)',
        overflow: 'hidden',
        backgroundColor: 'white',
    },
    overlayHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 'var(--gf-space-3, 12px)',
        backgroundColor: 'var(--gf-secondary-50, #F5F6F7)',
    },
    overlayCheckbox: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--gf-space-2, 8px)',
        flex: 1,
    },
    overlayControls: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--gf-space-2, 8px)',
    },
    filterButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        padding: 0,
        border: '1px solid var(--gf-border-color, #E5E7EB)',
        borderRadius: 'var(--gf-border-radius-md, 6px)',
        backgroundColor: 'white',
        color: 'var(--gf-secondary-500, #4B5563)',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
    },
    filterButtonActive: {
        backgroundColor: 'var(--gf-primary-400, #FD7218)',
        borderColor: 'var(--gf-primary-400, #FD7218)',
        color: 'white',
    },
    filterContent: {
        borderTop: '1px solid var(--gf-border-color, #E5E7EB)',
        padding: 'var(--gf-space-3, 12px)',
        fontSize: 'var(--gf-text-xs, 0.75rem)',
        backgroundColor: 'white',
    },
    inputGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--gf-space-2, 8px)',
    },
    inputLabel: {
        fontSize: 'var(--gf-text-xs, 0.75rem)',
        color: 'var(--gf-secondary-500, #4B5563)',
        whiteSpace: 'nowrap',
    },
    numberInput: {
        width: '70px',
        padding: 'var(--gf-space-1, 4px) var(--gf-space-2, 8px)',
        fontSize: 'var(--gf-text-sm, 0.875rem)',
        border: '1px solid var(--gf-border-color, #E5E7EB)',
        borderRadius: 'var(--gf-border-radius-sm, 4px)',
    },
    helpIcon: {
        color: 'var(--gf-secondary-400, #6B7280)',
        cursor: 'help',
    },
};

export function SideBar({
    setShowTenementPopup,
    setTenementFilters,
    tenementFilters,
    setTenementPopup,
    layerVisibility,
    setLayerVisibility,
    overlayVisibility,
    setOverlayVisisbility,
    assayMarkerColourSettings,
    setAssayMarkerColourSettings,
    assayFilters,
    setAssayFilters,
    assayGeoJson,
    setAssayGeoJson,
    minedexFilters,
    setMinedexFilters,
    setMinedexPopup,
    setShowMinedexPopup,
    drillHoleFilters,
    setDrillHoleFilters,
    drillHoleColourSettings,
    setDrilHoleColourSettings,
    drillHoleGeoJson,
    trigger40EWizard,
    presetsControl }) {

    const [tenementFiltersOpen, setTenementsFiltersOpen] = useState(false);
    const [soilsFiltersOpen, setSoilsFiltersOpen] = useState(false);
    const [minedexFiltersOpen, setMinedexFiltersOpen] = useState(false);
    const [drillholeFiltersOpen, setDrillholeFiltersOpen] = useState(false);

    const { goldfindermap } = useMap();

    const changeMapBaseLayer = (layerId) => {
        let tmp = {};
        for (let key in layerVisibility) {
            tmp[key] = layerId === key;
        }
        setLayerVisibility({ ...tmp })
    }

    const setPpbMoreThan = (val) => {
        setAssayFilters({ ...assayFilters, ppbmt: val.target.valueAsNumber });
    }

    const setDhGtMoreThan = (val) => {
        setDrillHoleFilters({ ...drillHoleFilters, gptmt: val.target.valueAsNumber });
    }

    const baseLayers = [
        { id: 'street', label: 'Street Maps' },
        { id: 'hybrid', label: 'Satellite Imagery' },
        { id: 'topo', label: 'Australia Topographic' },
        { id: 'geo100', label: '100k Geological Mosaic' },
        { id: 'geo200', label: '250k Geological Mosaic' },
        { id: 'magnetic', label: 'Magnetic Intensity (RTP)' },
    ];

    return (
        <div style={styles.sidebar}>
            {/* Header with Logo */}
            <div style={styles.header}>
                <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                    <img src={logo} alt="Gold Finder" style={{ height: '55px' }} />
                </a>
            </div>

            {/* Content */}
            <div style={styles.content}>
                {/* Base Maps Section */}
                <div style={styles.section}>
                    <div style={styles.sectionHeader}>
                        <FontAwesomeIcon icon={faMap} style={styles.sectionIcon} />
                        <h3 style={styles.sectionTitle}>Base Maps</h3>
                    </div>
                    <div style={styles.radioGroup}>
                        {baseLayers.map(layer => (
                            <label
                                key={layer.id}
                                style={{
                                    ...styles.radioItem,
                                    backgroundColor: layerVisibility[layer.id] ? 'var(--gf-primary-50, #FFF4ED)' : 'transparent',
                                }}
                            >
                                <Form.Check
                                    id={layer.id}
                                    name='baseLayerChange'
                                    label={layer.label}
                                    type="radio"
                                    checked={layerVisibility[layer.id]}
                                    onChange={() => changeMapBaseLayer(layer.id)}
                                    style={{ margin: 0 }}
                                />
                            </label>
                        ))}
                    </div>
                </div>

                {presetsControl}

                {/* Overlays Section */}
                <div style={styles.section}>
                    <div style={styles.sectionHeader}>
                        <FontAwesomeIcon icon={faLayerGroup} style={styles.sectionIcon} />
                        <h3 style={styles.sectionTitle}>Overlays</h3>
                    </div>

                    {/* Tenements Overlay */}
                    <div style={styles.overlayCard}>
                        <div style={styles.overlayHeader}>
                            <div style={styles.overlayCheckbox}>
                                <Form.Check
                                    id='tenements_overlay'
                                    label='Tenements'
                                    checked={overlayVisibility.tenements}
                                    onChange={() => setOverlayVisisbility({ ...overlayVisibility, tenements: !overlayVisibility.tenements })}
                                />
                            </div>
                            <button
                                style={{
                                    ...styles.filterButton,
                                    ...(tenementFiltersOpen ? styles.filterButtonActive : {}),
                                }}
                                onClick={() => setTenementsFiltersOpen(!tenementFiltersOpen)}
                                aria-expanded={tenementFiltersOpen}
                                title="Filter options"
                            >
                                <FontAwesomeIcon icon={tenementFiltersOpen ? faChevronUp : faFilter} size="sm" />
                            </button>
                        </div>
                        <Collapse in={tenementFiltersOpen}>
                            <div style={styles.filterContent}>
                                <TenementQueryTool
                                    setTenementFilters={setTenementFilters}
                                    tenementFilters={tenementFilters}
                                    setTenementPopup={setTenementPopup}
                                    goldfindermap={goldfindermap}
                                    setShowTenementPopup={setShowTenementPopup}
                                    overlayVisibility={overlayVisibility}
                                    setOverlayVisisbility={setOverlayVisisbility}
                                    trigger40EWizard={trigger40EWizard}
                                />
                            </div>
                        </Collapse>
                    </div>

                    {/* Soils Overlay */}
                    <div style={styles.overlayCard}>
                        <div style={styles.overlayHeader}>
                            <div style={styles.overlayCheckbox}>
                                <Form.Check
                                    id='soils-overlay'
                                    label='Soils'
                                    checked={overlayVisibility.soils}
                                    onChange={() => setOverlayVisisbility({ ...overlayVisibility, soils: !overlayVisibility.soils })}
                                />
                            </div>
                            <div style={styles.overlayControls}>
                                <div style={styles.inputGroup}>
                                    <span style={styles.inputLabel}>PPB &gt;</span>
                                    <FontAwesomeIcon
                                        icon={faQuestionCircle}
                                        size="xs"
                                        style={styles.helpIcon}
                                        title="Gold Parts Per Billion"
                                    />
                                    <Form.Control
                                        size="sm"
                                        style={styles.numberInput}
                                        defaultValue={assayFilters.ppbmt}
                                        onChange={setPpbMoreThan}
                                        type='number'
                                        step="1"
                                    />
                                </div>
                                <button
                                    style={{
                                        ...styles.filterButton,
                                        ...(soilsFiltersOpen ? styles.filterButtonActive : {}),
                                    }}
                                    onClick={() => setSoilsFiltersOpen(!soilsFiltersOpen)}
                                    aria-expanded={soilsFiltersOpen}
                                    title="Filter options"
                                >
                                    <FontAwesomeIcon icon={soilsFiltersOpen ? faChevronUp : faFilter} size="sm" />
                                </button>
                            </div>
                        </div>
                        <Collapse in={soilsFiltersOpen}>
                            <div style={styles.filterContent}>
                                <AssayQueryToolMapLibre
                                    assayGeoJson={assayGeoJson}
                                    assayMarkerColourSettings={assayMarkerColourSettings}
                                    setAssayMarkerColourSettings={setAssayMarkerColourSettings}
                                    assayFilters={assayFilters}
                                    setAssayFilters={setAssayFilters}
                                    goldfindermap={goldfindermap}
                                    setAssayGeoJson={setAssayGeoJson}
                                />
                            </div>
                        </Collapse>
                    </div>

                    {/* Drill Hole Overlay */}
                    <div style={styles.overlayCard}>
                        <div style={styles.overlayHeader}>
                            <div style={styles.overlayCheckbox}>
                                <Form.Check
                                    id='dh-overlay'
                                    label='Drill Hole'
                                    checked={overlayVisibility.dh}
                                    onChange={() => setOverlayVisisbility({ ...overlayVisibility, dh: !overlayVisibility.dh })}
                                />
                            </div>
                            <div style={styles.overlayControls}>
                                <div style={styles.inputGroup}>
                                    <span style={styles.inputLabel}>G/T &gt;</span>
                                    <FontAwesomeIcon
                                        icon={faQuestionCircle}
                                        size="xs"
                                        style={styles.helpIcon}
                                        title="Gold grams per tonne"
                                    />
                                    <Form.Control
                                        size="sm"
                                        style={styles.numberInput}
                                        defaultValue={drillHoleFilters.gptmt}
                                        onChange={setDhGtMoreThan}
                                        type='number'
                                        step="0.1"
                                    />
                                </div>
                                <button
                                    style={{
                                        ...styles.filterButton,
                                        ...(drillholeFiltersOpen ? styles.filterButtonActive : {}),
                                    }}
                                    onClick={() => setDrillholeFiltersOpen(!drillholeFiltersOpen)}
                                    aria-expanded={drillholeFiltersOpen}
                                    title="Filter options"
                                >
                                    <FontAwesomeIcon icon={drillholeFiltersOpen ? faChevronUp : faFilter} size="sm" />
                                </button>
                            </div>
                        </div>
                        <Collapse in={drillholeFiltersOpen}>
                            <div style={styles.filterContent}>
                                <DrillHoleQueryTool
                                    drillHoleFilters={drillHoleFilters}
                                    setDrillHoleFilters={setDrillHoleFilters}
                                    drillHoleColourSettings={drillHoleColourSettings}
                                    setDrilHoleColourSettings={setDrilHoleColourSettings}
                                    drillHoleGeoJson={drillHoleGeoJson}
                                />
                            </div>
                        </Collapse>
                    </div>

                    {/* MINEDEX Overlay */}
                    <div style={styles.overlayCard}>
                        <div style={styles.overlayHeader}>
                            <div style={styles.overlayCheckbox}>
                                <Form.Check
                                    id='minedex-overlay'
                                    label='MINEDEX Data'
                                    checked={overlayVisibility.minedex}
                                    onChange={() => setOverlayVisisbility({ ...overlayVisibility, minedex: !overlayVisibility.minedex })}
                                />
                            </div>
                            <button
                                style={{
                                    ...styles.filterButton,
                                    ...(minedexFiltersOpen ? styles.filterButtonActive : {}),
                                }}
                                onClick={() => setMinedexFiltersOpen(!minedexFiltersOpen)}
                                aria-expanded={minedexFiltersOpen}
                                title="Filter options"
                            >
                                <FontAwesomeIcon icon={minedexFiltersOpen ? faChevronUp : faFilter} size="sm" />
                            </button>
                        </div>
                        <Collapse in={minedexFiltersOpen}>
                            <div style={styles.filterContent}>
                                <MinedexQueryTool
                                    minedexFilters={minedexFilters}
                                    setMinedexFilters={setMinedexFilters}
                                    goldfindermap={goldfindermap}
                                    setMinedexPopup={setMinedexPopup}
                                    setShowMinedexPopup={setShowMinedexPopup}
                                />
                            </div>
                        </Collapse>
                    </div>

                    {/* Simple Overlays (no filters) */}
                    <div style={styles.overlayCard}>
                        <div style={styles.overlayHeader}>
                            <div style={styles.overlayCheckbox}>
                                <Form.Check
                                    id='graticles-overlay'
                                    label='1 Min Graticules'
                                    checked={overlayVisibility.graticles}
                                    onChange={() => setOverlayVisisbility({ ...overlayVisibility, graticles: !overlayVisibility.graticles })}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={styles.overlayCard}>
                        <div style={styles.overlayHeader}>
                            <div style={styles.overlayCheckbox}>
                                <Form.Check
                                    id='markers-overlay'
                                    label='Waypoints'
                                    checked={overlayVisibility.waypoints}
                                    onChange={() => setOverlayVisisbility({ ...overlayVisibility, waypoints: !overlayVisibility.waypoints })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
